import React, { useEffect } from 'react';
import L from 'leaflet';
import AvatarOverlay from '../MapDislay/AvatarOverlay';
import { joinRoom } from "../../../ControlPanel/store/interact/interactThunks";
import { useDispatch, useSelector } from 'react-redux';
import { startPause } from '../../../CoffeePause/store/coffePauseSlice'
import { addNotification } from '../../../Notifications/store/notificationsSlice';
import { useTranslation } from 'react-i18next';
import { addBreakTime } from '../../../CoffeePause/store/coffePauseThunks';
const MapObject = ({ object, mapRef, overlays }) => {
 
        useEffect(() => {
        if (!mapRef.current || !object || !object.lat || !overlays) return;

        const overlayId = `object-${object.id}`;
        const size = 15;
        const bounds = L.latLngBounds(
            [object.lat - size, object.lng - size],
            [object.lat + size, object.lng + size]
        );

        const html = `
        <div class="map-object-wrapper" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
            <img 
                src="${object.image}"
                alt="${object.name}"
                style="width: 100%; height: 100%; object-fit: contain; pointer-events: none;"
            />
        </div>
    `;

        if (!overlays.current[overlayId]) {
            overlays.current[overlayId] = new AvatarOverlay(html, bounds, {
                className: 'custom-map-object',
                interactive: true,
            });
            overlays.current[overlayId].addTo(mapRef.current);
        } else {
            overlays.current[overlayId].setBounds(bounds);
            const el = overlays.current[overlayId].getElement();
            if (el) el.innerHTML = html;
        }

        const element = overlays.current[overlayId].getElement();
        if (element) {
            element.style.zIndex = "400"; 
            element.style.pointerEvents = "auto"; 

         

            /*element.addEventListener('click', handleClick);*/

            return () => {
              /*  element.removeEventListener('click', handleClick);*/
            };
        }
    }, [object, mapRef, overlays]);
    return null;
};

export default MapObject;